import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ErrorMessage({
  title,
  message,
  type,
  illustration
}) {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "row",
    alignItems: "center",
    blockSize: "100%",
    children: /*#__PURE__*/_jsx(UIErrorMessage, {
      type: type,
      title: title,
      illustration: illustration,
      children: message ? /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: message
        })
      }) : null
    })
  });
}